export const DISABLED_ROW_WITH_OPACITY_CLASSNAME = 'disabled-row-with-opacity'
